import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
import DocsView from "@/shared/components/Docs/DocsView";

export default function Docs() {
  useDocumentTitle("Documentation");
  return <DocsView />;
}
